// extracted by mini-css-extract-plugin
export var content = "EventCard-module--content--61dd3";
export var cta = "EventCard-module--cta--65a70";
export var image = "EventCard-module--image--90353";
export var image_wrapper = "EventCard-module--image_wrapper--55919";
export var label = "EventCard-module--label--0c00a";
export var link_overlay = "EventCard-module--link_overlay--5bd9e";
export var title = "EventCard-module--title--aa601";
export var wrapper = "EventCard-module--wrapper--49fa7";